const gql = require("graphql-tag");

const DEVICE_RUNED = gql`
  subscription($deviceId: String!, $topicId: String!, $id: ID!) {
    DeviceRunned(deviceId: $deviceId, topicId: $topicId, id: $id) {
      v
      m
      e
    }
  }
`;
const DEVICE_LOGINOUT = gql`
  subscription($deviceId: String!) {
    DeviceLogInOut(deviceId: $deviceId) {
      state
    }
  }
`;

export const deviceSubscriptions = {
  DEVICE_RUNED,
  DEVICE_LOGINOUT,
};
